import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PartnersService {

    private _http = inject(HttpClient);

    getPartners(payload: any): Observable<any> {
        return this._http.post('partners/partners-list', payload);
    }
}
